import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin } from "lucide-react";
import { NAV_LINKS, DISCIPLINES } from "../../data/content";
import { Wordmark } from "./Navbar";

const socials = [
  {
    icon: Instagram,
    label: "Kumite Games on Instagram",
    href: "https://www.instagram.com/kumitegames/",
    testId: "social-instagram",
  },
  {
    icon: Facebook,
    label: "Kumite Games on Facebook",
    href: "https://www.facebook.com/kumitegamesnz/",
    testId: "social-facebook",
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/5 bg-[#050506]">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Wordmark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            One Event. Many Disciplines. One Martial Arts Community. Aotearoa New Zealand's
            premier multi-discipline martial arts festival.
          </p>
          <p className="mt-6 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">
            <MapPin className="h-3.5 w-3.5" /> New Zealand
          </p>
          <div className="mt-8 flex gap-3">
            {socials.map((s) => (
              <a
                key={s.testId}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testId}
                aria-label={s.label}
                className="grid h-10 w-10 place-items-center border border-white/10 text-slate-400 transition-all duration-300 hover:border-kred hover:text-kred"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-kred">
            Navigate
          </h3>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-bone"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-kred">
            Martial Arts
          </h3>
          <ul className="mt-6 space-y-3">
            {DISCIPLINES.map((d) => (
              <li key={d.slug}>
                <Link
                  to={`/disciplines/${d.slug}`}
                  data-testid={`footer-discipline-${d.slug}`}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-bone"
                >
                  {d.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-kred">
            Contact
          </h3>
          <p className="mt-6 text-sm leading-relaxed text-slate-400">
            For all enquiries — federations, sponsorship, media and athletes — please use our
            official contact form.
          </p>
          <Link
            to="/contact"
            data-testid="footer-contact-link"
            className="clip-notch-sm mt-6 inline-block border border-gold/40 px-6 py-3 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
          >
            Contact Us
          </Link>
        </div>
      </div>
      <div className="mt-16 flex flex-col items-center justify-between gap-6 border-t border-white/5 pt-8 sm:flex-row">
        <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          © Kumite Games. All rights reserved.
        </p>
        <div className="flex gap-8">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 transition-colors hover:text-bone"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 transition-colors hover:text-bone"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
